export default "__VITE_ASSET__BvweFnWf__"